import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

export const fireFieldUpdateErrorAnalytics = (): void => {
	fireErrorAnalytics({
		meta: {
			id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
			packageName: 'jiraSoftwareReleasesLaunchCard',
			teamName: 'jolt',
		},
		error: Error('Unable to update version'),
		sendToPrivacyUnsafeSplunk: true,
	});
};
